module.exports = __webpack_public_path__ + "media/images/shared/suppliers/ENERGIZER-0e6dcde3ebf974d16207daaec9e1f18f.jpg";